module.exports = __webpack_public_path__ + "img/rd.6141fefd.jpg";